
  <!-- Copyright &copy; {{ footerDate | date: "yyyy" }}
  <a href="https://www.sdglobaltech.com/" target="_blank"
    >www.sdglobaltech.com</a
  >
  ( {{ medcareVersion | translate }} ) | All Rights Reserved -->
  
  <div class="footer-content" *ngIf="showFooter">
    <div class="refresh-button">
      <mat-icon style="color:#339480; cursor: pointer;" [matTooltip]="'RegistrationPage.refresh' | translate" (click)="onRefreshClick()">
      refresh
      </mat-icon>
    </div>
    <!-- <div>
      <mat-paginator
      [length]="totalDataLength"
      [pageIndex]="pageIndex"
      [pageSize]="pageSize"
      [pageSizeOptions]="paginatorOptions"
      (page)="getNext($event)">
      </mat-paginator>
    </div> -->
     <div class="pagination-content">
        <span>{{ totalDataLength ?? 0}} {{'footer.Records' | translate}}, {{ totalPages() }} {{'footer.Pagesintotal' | translate}}</span>
        <mat-paginator
          appBubblePagination
          [appCustomLength]="totalDataLength"
          [length]="totalDataLength"
          [pageSize]="pageSize"
          (page)="getNext($event)"
          [appPageIndex]="pageIndex"
          #paginator
          [pageSizeOptions]="paginatorOptions"
          [showFirstLastButtons]="true"
        >
        </mat-paginator>
      </div>
    </div>  
